/**
 * This component will show a product detail line
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import { css, rtlConvertInline } from 'lib/paypalphrodite'
import EnglishSubtitleText from './english-subtitle-text'
import { BodyText, CaptionText, v2grey600 } from '@paypalcorp/pp-react'

export default class ProductDetailLine extends Component {
  static propTypes = {
    showENSubTextRTR: PropTypes.bool,
    styles: PropTypes.object,
    firstText: PropTypes.string,
    enSubText: PropTypes.string,
    secondText: PropTypes.string,
    isDw2Repaint: PropTypes.bool,
    ReviewInfoDiv: PropTypes.func,
  }

  render() {
    const {
      showENSubTextRTR,
      styles,
      firstText,
      enSubText = '',
      secondText,
      isDw2Repaint = false,
      ReviewInfoDiv,
    } = this.props

    return isDw2Repaint ? (
      <>
        <ReviewInfoDiv>
          <div>
            <BodyText>{firstText}</BodyText>
            {showENSubTextRTR && (
              <CaptionText style={{ color: v2grey600 }}>
                {enSubText}
              </CaptionText>
            )}
          </div>
          <BodyText data-nemo="total-sender-pay">{secondText}</BodyText>
        </ReviewInfoDiv>
      </>
    ) : (
      <>
        <div
          className={`${css(rtlConvertInline(styles.txtAlignLeft))} vx_text-5`}
        >
          <div
            className={classNames(
              css(rtlConvertInline(styles.txtAlignLeft)),
              'col-xs-7',
              css(rtlConvertInline(styles.leftBlock))
            )}
          >
            <EnglishSubtitleText
              showENSubTextRTR={showENSubTextRTR}
              styles={styles}
              text={firstText}
              enSubText={enSubText}
            />
          </div>
          <div
            className={classNames(
              css(rtlConvertInline(styles.txtAlignRight)),
              'col-xs-7',
              'totalAmount col-xs-5 txtAlignRight test_senderPay',
              css(rtlConvertInline(styles.rightBlock))
            )}
            data-nemo="total-sender-pay"
          >
            {secondText}
          </div>
        </div>
      </>
    )
  }
}
